import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Loyaltic } from './api-url.constants';
import { OpenMeteoGeocodingResponse, WeatherLocationResolution, WeatherOcrContext } from '../models/weather-bonus.models';
import { WeatherContextNormalizerService } from './weather-context-normalizer.service';

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {
  private readonly geocodingUrl = environment.baseUrl + Loyaltic.API.WeatherGeocode;
  public lastDebug: { candidate: string; response: OpenMeteoGeocodingResponse | null; candidates: string[] } | null = null;

  constructor(
    private http: HttpClient,
    private normalizer: WeatherContextNormalizerService
  ) {}

  async resolve(context: WeatherOcrContext): Promise<WeatherLocationResolution> {
    const candidates = this.normalizer.buildAddressCandidates(context);
    this.lastDebug = {
      candidate: '',
      response: null,
      candidates
    };

    for (let index = 0; index < candidates.length; index++) {
      const candidate = candidates[index];
      const params = new HttpParams()
        .set('query', candidate);

      const response = await this.http.get<OpenMeteoGeocodingResponse>(this.geocodingUrl, { params }).toPromise();
      this.lastDebug = {
        candidate,
        response,
        candidates
      };
      const bestMatch = response && response.results && response.results.length > 0 ? response.results[0] : null;
      if (!bestMatch) {
        continue;
      }

      return {
        resolutionLevel: this.resolveLevel(index),
        inputAddress: candidate,
        normalizedAddress: `${bestMatch.name || ''}, ${bestMatch.admin1 || ''}, ${bestMatch.country || 'Sweden'}`.replace(/(,\s*){2,}/g, ', ').replace(/^,\s*|\s*,$/g, ''),
        latitude: bestMatch.latitude,
        longitude: bestMatch.longitude,
        geocodingProvider: 'open-meteo',
        geocodingConfidence: index === 0 ? 'high' : index < 3 ? 'medium' : 'low'
      };
    }

    return {
      resolutionLevel: 'unresolved',
      inputAddress: candidates[0] || '',
      normalizedAddress: '',
      latitude: null,
      longitude: null,
      geocodingProvider: 'open-meteo',
      geocodingConfidence: 'unknown'
    };
  }

  private resolveLevel(index: number): string {
    switch (index) {
      case 0:
        return 'full_address';
      case 1:
        return 'street_city';
      case 2:
        return 'street_city';
      case 3:
        return 'postal_city';
      default:
        return 'city_only';
    }
  }
}
